module.exports = __webpack_public_path__ + "img/infoa.10d20155.svg";